import { Component } from '@angular/core';

import { FormlyFieldBaseComponent } from '../formly-field-base.component';

@Component({
  selector: 'app-formly-checkbox',
  templateUrl: './formly-checkbox.component.html',
  styleUrl: './formly-checkbox.component.scss',
})
export class FormlyCheckboxComponent extends FormlyFieldBaseComponent {
  change(event: any) {
    if (this.props.onChange) {
      this.props.onChange(event.target.value);
    }
  }
}
